import { IPrivateEndpointMetadata } from './private-endpoint-metadata';

import { getSqlControls, getReadonlyControl, sqlResourceIdFormat, sqlResourceIdErrorMessage } from './shared-control-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const sqlServerPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Sql/servers',
    connectionSuffix: 'privateEndpoints',
    resourceIdValidator: sqlResourceIdFormat,
    groupIdMetadata: {
        sqlServer: {
            linkedServiceType: adfModelTypeMap.azureSql.linkedServiceType,
            groupId: 'sqlServer',
            iconClass: 'svg-i-100x100-AzureSQLDatabase',
            displayName: stringResources.AzureSql_DisplayText,
            controls: {
                creationControls: getSqlControls(false),
                readonlyControls: getReadonlyControl(sqlResourceIdFormat, sqlResourceIdErrorMessage)
            }
        }
    }
};
